(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if (document.visibilityState === 'visible') {
    init();
  } else {
    document.addEventListener('visibilitychange', function onVisible() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', onVisible);
      init();
    });
  }

  function init() {

  var textTargets = [
    '.t2-scope .t2-section:not(.t2-hero) > .t2-container > .t2-label',
    '.t2-scope .t2-section:not(.t2-hero) > .t2-container > h2',
    '.t2-scope .t2-section:not(.t2-hero) > .t2-container > .t2-lede',
    '.t2-scope .t2-section:not(.t2-hero) > .t2-container > .t2-prose',
    '.t2-scope .t2-section:not(.t2-hero) > .t2-container > .t2-journey-index__foot'
  ].join(',');

  var groupTargets = [
    '.t2-journey-index > .t2-journey-tile',
    '.t2-editorial__grid > *',
    '.t2-proof > .t2-proof__stat',
    '.t2-journey-related > *',
    '.t2-journey__gallery-rail > *',
    '.t2-interest'
  ].join(',');

  var fold = window.innerHeight * 0.92;

  function prepare(nodes, staggered) {
    var byParent = new Map();
    nodes.forEach(function (el) {
      if (el.classList.contains('t2-reveal')) return;
      if (el.getBoundingClientRect().top < fold) return;
      var parent = el.parentElement;
      var index = 0;
      if (staggered) {
        index = byParent.get(parent) || 0;
        byParent.set(parent, index + 1);
      }
      el.style.setProperty('--t2-i', Math.min(index, 6));
      el.classList.add('t2-reveal');
    });
  }

  prepare(Array.prototype.slice.call(document.querySelectorAll(textTargets)), false);
  prepare(Array.prototype.slice.call(document.querySelectorAll(groupTargets)), true);

  var all = Array.prototype.slice.call(document.querySelectorAll('.t2-reveal'));
  if (!all.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  all.forEach(function (el) { observer.observe(el); });

  window.setTimeout(function () {
    all.forEach(function (el) { el.classList.add('is-in'); });
  }, 2500);
  }
})();
